import InventoryListItem from "./InventoryListItem";
import { InventoryItem } from "@1games-ru/region-shared/dist/types/inventory/inventory";
import { useDndMonitor, useDroppable } from "@dnd-kit/core";
import clsx from "clsx";

type Props = {
  inventoryId: number;
  tradeId?: number;
  equipmentId?: number;
  items: InventoryItem[];
  onDrop?: (fromInventoryId: number, item: InventoryItem) => void | Promise<void>;
  onRefresh?: () => Promise<void> | void;
  onPick?: (fromInventoryId: number, item: InventoryItem) => void | Promise<void>;
  disabled?: boolean;
  disabledItems?: string[];
};

export default function InventoryList({
  inventoryId,
  tradeId,
  equipmentId,
  items,
  onDrop,
  onRefresh,
  onPick,
  disabled,
}: Props) {
  const { setNodeRef, isOver } = useDroppable({
    id: `list-inv${inventoryId}-trade${tradeId}-eqv${equipmentId}`,
    disabled,
  });

  useDndMonitor({
    onDragEnd: async (event) => {
      const activeItem = event.active.data.current;
      if (!event.over) return;
      const overId = String(event.over.id);
      if (!overId.includes(`inv${inventoryId}`)) {
        return;
      }

      if (!activeItem) return;

      try {
        await onDrop?.(activeItem.inventoryId, activeItem as InventoryItem);
      } catch (e) {
        console.log(e);
      } finally {
        await onRefresh?.();
      }
    },
    onDragMove(event) {
      if (!event.over) return;
      const overId = String(event.over.id);
      // Обрабатываем только если дроп был в ЭТУ сетку
      if (!overId.includes(`inv${inventoryId}`)) {
        return;
      }
    },
  });

  return (
    <div
      ref={setNodeRef}
      className={clsx("w-full flex flex-col grow gap-1 transition-all  rounded-[0.8rem]", {
        "pointer-events-none": disabled,
        "bg-green/10": isOver,
      })}
    >
      {items.map((item) => (
        <InventoryListItem
          inventoryId={inventoryId}
          key={item.id}
          item={item}
          onClick={onPick}
          onRefresh={onRefresh}
        />
      ))}
    </div>
  );
}
